var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"result",attrs:{"href":_vm.url,"title":_vm.url},domProps:{"innerHTML":_vm._s(_vm.htmlText + _vm.categoryText)},on:{"click":function($event){return _vm.onClick()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }